import { render, staticRenderFns } from "./table-positions.component.vue?vue&type=template&id=de197b1c&scoped=true"
import script from "./table-positions.component.vue?vue&type=script&lang=js"
export * from "./table-positions.component.vue?vue&type=script&lang=js"
import style0 from "./table-positions.component.vue?vue&type=style&index=0&id=de197b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de197b1c",
  null
  
)

export default component.exports